import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetTransfer = gql`
  query GetTransfer($id: ID!) {
    transfer(id: $id) {
      id
      value {
        ...money
      }
      details {
        id
        title
        items {
          ... on TransferDetailItemAccountName {
            id
            title
            description
            accountId
            value
          }
          ... on TransferDetailItemDate {
            id
            title
            copy
            description
          }
          ... on TransferDetailItemStatus {
            id
            title
            copy
            description
          }
          ... on IDetailItem {
            id
            title
            description
            __typename
          }
          ... on ITransferDetailItem {
            id
            title
            description
            __typename
          }
          ... on IDetailCopyItem {
            copy
            __typename
          }
        }
      }
      disclaimer
    }
  }
  ${money}
`;

export default GetTransfer;
